bam-search-results {
  display: block;
  margin-bottom: -24px;
  width: 100%;

  @include tablet() {
    margin-bottom: 16px;
  }

  .bam-search-results__input-wrapper {
    padding: 0 !important;

    @include tablet() {
      padding-left: 16px !important;
      padding-right: 8px !important;
    }
  }

  .bam-search-results__button-wrapper {
    padding: 0 !important;

    @include tablet() {
      padding-right: 16px !important;
    }
  }
}
